var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictogramPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Authorisation-Required-Screen",
    transform: "translate(-161.000000, -135.000000)",
    className: "brandable",
    fill: "#0884FD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paper-plane",
    transform: "translate(161.000000, 135.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8441591,0.46473071 L1.71729525,28.2212212 C-0.753503558,29.6498641 -0.506423677,33.2912922 2.12551419,34.3762015 L17.1866443,40.6063735 L17.1866443,51.5628829 C17.1866443,54.806869 21.2473485,56.2140286 23.2777005,53.7434431 L29.7984609,45.8160863 L43.3771118,51.4232411 C45.428949,52.2718335 47.7493514,50.9720908 48.0823721,48.7700472 L54.9576384,3.96651705 C55.3980851,1.09848959 52.3149579,-0.963912184 49.8441591,0.46473071 Z M20.6242775,51.5628829 L20.6242775,42.0242747 L26.4789964,44.4411518 L20.6242775,51.5628829 Z M44.6877094,48.2437051 L22.5364609,39.0917972 L43.9679549,13.7629255 C44.4835999,13.1613916 43.6564194,12.3450242 43.0548336,12.8606247 L15.6289668,36.2345114 L3.43611182,31.2074071 L51.5629756,3.44017493 L44.6877094,48.2437051 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramPlane);
export default __webpack_public_path__ + "static/media/pictogram-plane.0f7c61ea9d6ab52223628b6cafddf49a.svg";
export { ForwardRef as ReactComponent };